const breadCrumb = "Rendimento - Rendimento";

const routes = [
  {
    path: "/consulta-solicitacao-da-geracao-de-rendimento",
    name: "consulta-solicitacao-da-geracao-de-rendimento",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarSolicitacaoDaGeracaoDoRendimento/ConsultarSolicitacaoDaGeracaoDoRendimento.vue"
      ),
  },
];

export default routes;
